module.exports = "/_next/static/images/415637c1373b703e6bc878b7d31c72d0-slide-4-small.png.webp";